// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as ModalBody from "../../../../library/reuseable-components/ModalBody.bs.js";
import * as Belt_Result from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ModalFooter from "../../../../library/reuseable-components/ModalFooter.bs.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CorePricingContext from "../../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as FomDateInputTs$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FomDateInputTs.bs.js";
import * as CampaignModificationType from "../../../../../../app/pricing-modifications/entity/CampaignModificationType.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";

var validators_end_date = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var end_date = param.end_date;
      var start_date = param.start_date;
      if (start_date === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please select a start date first"
              };
      }
      if (end_date === undefined) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      var end_date$1 = Caml_option.valFromOption(end_date);
      var start_date$1 = Caml_option.valFromOption(start_date);
      var isEndDateBeforeStartDate = Timestamp$Catalyst.isBefore(end_date$1, start_date$1);
      if (isEndDateBeforeStartDate) {
        return {
                TAG: /* Error */1,
                _0: "End date cannot be before start date"
              };
      }
      if (param.modification_type) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(end_date$1)
              };
      }
      var maxAllowedDate = Timestamp$Catalyst.getDateTimeAfterElapsedTime(4.0, /* Months */2, start_date$1);
      var match = Timestamp$Catalyst.isAfter(end_date$1, maxAllowedDate);
      if (match) {
        return {
                TAG: /* Error */1,
                _0: "Experiment duration cannot be more than 4 months"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(end_date$1)
              };
      }
    })
};

var validators_start_date = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var start_date = param.start_date;
      if (start_date !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.valFromOption(start_date)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Start date is required"
              };
      }
    })
};

var validators_modification_name = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.modification_name
                    }), (function (name) {
                    if (name.length > 60) {
                      return {
                              TAG: /* Error */1,
                              _0: "Modification Name cannot be more than 60 characters"
                            };
                    } else if (name.length < 3) {
                      return {
                              TAG: /* Error */1,
                              _0: "Modification Name cannot be less than 3 characters"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: name
                            };
                    }
                  }));
    })
};

var validators = {
  end_date: validators_end_date,
  start_date: validators_start_date,
  modification_name: validators_modification_name,
  modification_type: undefined,
  vehicle: undefined,
  region: undefined
};

function initialFieldsStatuses(_input) {
  return {
          end_date: /* Pristine */0,
          start_date: /* Pristine */0,
          modification_name: /* Pristine */0,
          modification_type: /* Pristine */0,
          vehicle: /* Pristine */0,
          region: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.end_date;
  var match_0 = match ? match._0 : Curry._1(validators.end_date.validate, input);
  var match$1 = fieldsStatuses.start_date;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.start_date.validate, input);
  var match$2 = fieldsStatuses.modification_name;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.modification_name.validate, input);
  var match_0$3 = {
    TAG: /* Ok */0,
    _0: input.modification_type
  };
  var match_0$4 = {
    TAG: /* Ok */0,
    _0: input.vehicle
  };
  var match_0$5 = {
    TAG: /* Ok */0,
    _0: input.region
  };
  var end_dateResult = match_0;
  var end_dateResult$1;
  if (end_dateResult.TAG === /* Ok */0) {
    var start_dateResult = match_0$1;
    if (start_dateResult.TAG === /* Ok */0) {
      var modification_nameResult = match_0$2;
      if (modification_nameResult.TAG === /* Ok */0) {
        var modification_typeResult = match_0$3;
        if (modification_typeResult.TAG === /* Ok */0) {
          var vehicleResult = match_0$4;
          if (vehicleResult.TAG === /* Ok */0) {
            var regionResult = match_0$5;
            if (regionResult.TAG === /* Ok */0) {
              return {
                      TAG: /* Valid */0,
                      output: {
                        region: regionResult._0,
                        vehicle: vehicleResult._0,
                        modification_type: modification_typeResult._0,
                        modification_name: modification_nameResult._0,
                        start_date: start_dateResult._0,
                        end_date: end_dateResult._0
                      },
                      fieldsStatuses: {
                        end_date: /* Dirty */{
                          _0: end_dateResult,
                          _1: /* Shown */0
                        },
                        start_date: /* Dirty */{
                          _0: start_dateResult,
                          _1: /* Shown */0
                        },
                        modification_name: /* Dirty */{
                          _0: modification_nameResult,
                          _1: /* Shown */0
                        },
                        modification_type: /* Dirty */{
                          _0: modification_typeResult,
                          _1: /* Hidden */1
                        },
                        vehicle: /* Dirty */{
                          _0: vehicleResult,
                          _1: /* Hidden */1
                        },
                        region: /* Dirty */{
                          _0: regionResult,
                          _1: /* Hidden */1
                        }
                      },
                      collectionsStatuses: undefined
                    };
            }
            end_dateResult$1 = end_dateResult;
          } else {
            end_dateResult$1 = end_dateResult;
          }
        } else {
          end_dateResult$1 = end_dateResult;
        }
      } else {
        end_dateResult$1 = end_dateResult;
      }
    } else {
      end_dateResult$1 = end_dateResult;
    }
  } else {
    end_dateResult$1 = end_dateResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            end_date: /* Dirty */{
              _0: end_dateResult$1,
              _1: /* Shown */0
            },
            start_date: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            modification_name: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            modification_type: /* Dirty */{
              _0: match_0$3,
              _1: /* Hidden */1
            },
            vehicle: /* Dirty */{
              _0: match_0$4,
              _1: /* Hidden */1
            },
            region: /* Dirty */{
              _0: match_0$5,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurEnd_dateField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.end_date, validators_end_date, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  end_date: status,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStart_dateField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.start_date, validators_start_date, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  end_date: init.end_date,
                                  start_date: status,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurModification_nameField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.modification_name, validators_modification_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: status,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurModification_typeField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithoutValidator(state.input.modification_type, state.fieldsStatuses.modification_type, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: status,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurVehicleField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithoutValidator(state.input.vehicle, state.fieldsStatuses.vehicle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: status,
                                  region: init.region
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurRegionField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithoutValidator(state.input.region, state.fieldsStatuses.region, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: status
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */6 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */6,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */7,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */9);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */8);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */7 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */8 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */9 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateEnd_dateField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.end_date, state.submissionStatus, validators_end_date, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            end_date: status,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStart_dateField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$6 = Formality.validateDependentFieldOnChange(nextInput$1, nextFieldsStatuses.contents.end_date, validators_end_date, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  end_date: status,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$6 !== undefined) {
                    nextFieldsStatuses.contents = result$6;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, nextFieldsStatuses.contents.start_date, state.submissionStatus, validators_start_date, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            end_date: init.end_date,
                                            start_date: status,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateModification_nameField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.modification_name, state.submissionStatus, validators_modification_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: status,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateModification_typeField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$3.modification_type, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: status,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateVehicleField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$4.vehicle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: status,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateRegionField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$5.region, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */6 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */7 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */8 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateEnd_date: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEnd_dateField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStart_date: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStart_dateField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateModification_name: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateModification_nameField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateModification_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateModification_typeField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateVehicle: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateVehicleField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateRegion: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateRegionField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurEnd_date: (function (param) {
              return Curry._1(dispatch, /* BlurEnd_dateField */0);
            }),
          blurStart_date: (function (param) {
              return Curry._1(dispatch, /* BlurStart_dateField */1);
            }),
          blurModification_name: (function (param) {
              return Curry._1(dispatch, /* BlurModification_nameField */2);
            }),
          blurModification_type: (function (param) {
              return Curry._1(dispatch, /* BlurModification_typeField */3);
            }),
          blurVehicle: (function (param) {
              return Curry._1(dispatch, /* BlurVehicleField */4);
            }),
          blurRegion: (function (param) {
              return Curry._1(dispatch, /* BlurRegionField */5);
            }),
          end_dateResult: Formality.exposeFieldResult(state.fieldsStatuses.end_date),
          start_dateResult: Formality.exposeFieldResult(state.fieldsStatuses.start_date),
          modification_nameResult: Formality.exposeFieldResult(state.fieldsStatuses.modification_name),
          modification_typeResult: Formality.exposeFieldResult(state.fieldsStatuses.modification_type),
          vehicleResult: Formality.exposeFieldResult(state.fieldsStatuses.vehicle),
          regionResult: Formality.exposeFieldResult(state.fieldsStatuses.region),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.end_date || match.start_date || match.modification_name || match.modification_type || match.vehicle || match.region) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */6);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */7);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */8);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */8,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */9);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialState(key_details, region, vehicle, modification_type) {
  if (key_details !== undefined) {
    return {
            region: region,
            vehicle: vehicle,
            modification_type: modification_type,
            modification_name: key_details.name,
            start_date: Caml_option.some(key_details.start_date),
            end_date: key_details.end_date
          };
  } else {
    return {
            region: region,
            vehicle: vehicle,
            modification_type: modification_type,
            modification_name: "",
            start_date: undefined,
            end_date: undefined
          };
  }
}

function SimpleModificationKeyDetailsForm(Props) {
  var key_details = Props.key_details;
  var core_pricing_start_date = Props.core_pricing_start_date;
  var modification_type = Props.modification_type;
  var onNext = Props.onNext;
  var onBack = Props.onBack;
  var match = CorePricingContext.useContext(undefined);
  var vehicle_name = match.vehicle_type.vehicle_name;
  var geo_region_name = match.geo_region.geo_region_name;
  var form = useForm(getInitialState(key_details, geo_region_name, vehicle_name, modification_type), (function (output, param) {
          return Curry._1(onNext, {
                      region: geo_region_name,
                      vehicle: vehicle_name,
                      modification_type: output.modification_type,
                      name: output.modification_name,
                      start_date: output.start_date,
                      end_date: output.end_date
                    });
        }));
  return React.createElement(React.Fragment, undefined, React.createElement(ModalBody.make, {
                  className: "c-key-details-form",
                  children: null
                }, React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Geolocation"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                  
                                }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "non-error-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.region
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Vehicle ID"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                  
                                }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "non-error-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.vehicle
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Modification Type"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                  
                                }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "non-error-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: CampaignModificationType.to_string(form.input.modification_type)
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Modification Name"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateModification_name, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        modification_type: input.modification_type,
                                                        modification_name: value,
                                                        start_date: input.start_date,
                                                        end_date: input.end_date
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.modification_nameResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Campaign Names cannot be more than 60 characters"
                              }, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.modification_name
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Start Date"), React.createElement(FomDateInputTs$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (param) {
                                  
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.start_dateResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          date_props: FomDateInputTs$Catalyst.make_props(form.input.start_date, Caml_option.some(Timestamp$Catalyst.isAfter(core_pricing_start_date, Timestamp$Catalyst.tomorrow(undefined)) ? core_pricing_start_date : Timestamp$Catalyst.tomorrow(undefined)), Caml_option.some(Timestamp$Catalyst.getDateTimeAfterElapsedTime(180.0, /* Days */4, Timestamp$Catalyst.tomorrow(undefined))), (function (date) {
                                  return Curry._2(form.updateStart_date, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        modification_type: input.modification_type,
                                                        modification_name: input.modification_name,
                                                        start_date: value,
                                                        end_date: input.end_date
                                                      };
                                              }), Caml_option.some(date));
                                }), "DD/MM/YYYY", undefined, undefined, undefined, undefined)
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(LabelUnit$Catalyst.make, {
                          label: "End Date",
                          unit: "optional"
                        }), React.createElement(FomDateInputTs$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (param) {
                                  
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.end_dateResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: ""
                              }, undefined, undefined, undefined, undefined, undefined),
                          date_props: FomDateInputTs$Catalyst.make_props(form.input.end_date, form.input.start_date, Caml_option.some(Timestamp$Catalyst.getDateTimeAfterElapsedTime(180.0, /* Days */4, Timestamp$Catalyst.tomorrow(undefined))), (function (date) {
                                  return Curry._2(form.updateEnd_date, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        modification_type: input.modification_type,
                                                        modification_name: input.modification_name,
                                                        start_date: input.start_date,
                                                        end_date: value
                                                      };
                                              }), Caml_option.some(date));
                                }), "DD/MM/YYYY", undefined, undefined, undefined, undefined)
                        }))), React.createElement(ModalFooter.make, {
                  children: null
                }, React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Cancel"
                          }, undefined, (function (param) {
                              return Curry._1(onBack, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined)
                    }), React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Next"
                          }, undefined, (function (param) {
                              return Curry._1(form.submit, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined)
                    })));
}

var make = SimpleModificationKeyDetailsForm;

export {
  Form ,
  getInitialState ,
  make ,
  
}
/* react Not a pure module */
